import React from 'react';
import { useDataFetcher } from '../../../hooks';
import { Container } from 'react-bootstrap';
import { FormHeading, Well } from '../../../form';
import { RouteButton } from '../../../form/routeButton';
import AjaxErrorBoundary from '../../../ajax/errorBoundary';
import { ThemeList } from './ThemeList';

export const ThemeListPage: React.FC = () => {
  const { busy, errors, data } = useDataFetcher('/api/themes');

  const themes = data?.themes || [];

  return (
    <Container fluid>
      <Well>
        <FormHeading title="Themes" subTitle="List" backPath="/admin" />
        <RouteButton className="mb-2" to="/admin/themes/create">
          Create a new theme
        </RouteButton>
        <AjaxErrorBoundary
          busy={busy}
          loadingText="Loading themes"
          errors={errors}
        >
          <ThemeList themes={themes} />
        </AjaxErrorBoundary>
      </Well>
    </Container>
  );
};
